export default function LearningsList({ lessons = [] }) {
  return (
    <div className="rtv2-lessons">
      {lessons.map((l) => (
        <article key={l.id} className="rtv2-lesson">
          <span className="num">{String(l.id).padStart(2, "0")}</span>
          <div className="body">
            <div className="top-row">
              <span className={`src ${l.source}`}>{l.source}</span>
              <span className="when">{l.when}</span>
            </div>
            <h4>{l.title}</h4>
            <p>{l.body}</p>
            <div className="takeaway">
              <span>Apply to</span>
              <p>{l.applyTo}</p>
            </div>
          </div>
          <div className="meta">
            <span className="tag">{l.tag}</span>
            <span>{l.endorsements}</span>
          </div>
        </article>
      ))}
    </div>
  );
}
